module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAIVBMVEUTiAhMTJNksVyZmcKrq82urs7V1eb6+vz/mTP/vHn///9sYfvLAAAAL0lEQVQY02PoQAUM1ObPRAUMq8CgxNgdwoDy3UJTUPimgsF4+ejqEeYpoQIGGgMAPJ5vorIgl94AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/in.png
// module id = 842
// module chunks = 0